function refreshCart() {
  const this_cartDrawer = document.querySelector('cart-drawer');
  if (this_cartDrawer && typeof this_cartDrawer.refresh === 'function') {
    this_cartDrawer.refresh(true);
  }
}

async function applyDiscountCode(discountCode) {
  const cart = await fetch("/cart.js").then((response => response.json()))
  const discountCodes = Array.from(new Set([
      ...cart.discount_codes
      .filter(coupon => coupon.applicable)
      .map(coupon => coupon.code),
    discountCode
  ]));

  const formData = new FormData();
  formData.append("discount", discountCodes.join(","));

  return await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  }).then(response => response.json()).then((data) => {
    console.log(data)
    refreshCart()
  }).catch(err => {
    console.error("Erro inesperado:", err);
  })
}

async function removeDiscountCode(discountCode) {
  const cart = await fetch("/cart.js").then((response => response.json()))
  const discountCodes = Array.from(new Set([
      ...cart.discount_codes
      .filter(coupon => coupon.applicable)
      .map(coupon => coupon.code)
      .filter(code => code.toLowerCase() !== discountCode.toLowerCase())
  ]));

  const formData = new FormData();
  formData.append("discount", discountCodes.join(","));

  return await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  }).then(response => response.json()).then(() => {
    refreshCart()
  }).catch(err => {
    console.error("Erro inesperado:", err);
  })
}

document.addEventListener('click', function (event) {
  if (event.target.id === 'applyCouponButton') {
    const button = event.target;
    const textSpan = button.querySelector('.button-text');
    const spinner = button.querySelector('.spinner');
    const discountCode = document.getElementById('couponInput')?.value;

    if (discountCode) {
      button.disabled = true;
      textSpan.textContent = '';
      spinner.style.display = 'inline-block';

      applyDiscountCode(discountCode)
        .finally(() => {
          button.disabled = false;
          textSpan.textContent = 'Aplicar';
          spinner.style.display = 'none';
        });
    } else {
      alert('Por favor, insira um código de cupom.');
    }
  }
})